import { render, staticRenderFns } from "./AddEventPhotos.vue?vue&type=template&id=efc4e2aa&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddEventPhotos.vue"
export default component.exports